var exports = {
  "Qs": "ExternalLinkWarningModal.module__content___VlFaaF",
  "zc": "ExternalLinkWarningModal.module__iconContainer___VlFaaF",
  "kJ": "ExternalLinkWarningModal.module__iconCircle___VlFaaF",
  "QW": "ExternalLinkWarningModal.module__warningIcon___VlFaaF",
  "FS": "ExternalLinkWarningModal.module__textContainer___VlFaaF",
  "DD": "ExternalLinkWarningModal.module__title___VlFaaF",
  "h_": "ExternalLinkWarningModal.module__description___VlFaaF",
  "VU": "ExternalLinkWarningModal.module__urlSection___VlFaaF",
  "A7": "ExternalLinkWarningModal.module__urlLabel___VlFaaF",
  "vQ": "ExternalLinkWarningModal.module__urlBox___VlFaaF",
  "xG": "ExternalLinkWarningModal.module__urlText___VlFaaF",
  "mH": "ExternalLinkWarningModal.module__checkboxLabel___VlFaaF",
  "x6": "ExternalLinkWarningModal.module__button___VlFaaF",
};

module.exports = exports;
